import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'case'
})
export class CasePipe implements PipeTransform {

	transform(value: any, args: string = "All"): number {
		if (value) {
			switch (args.toLowerCase()) {
				case "all":
					return value.All;
				case "mine":
					return value.Mine;
				case "unassigned":
					return value.Unassigned;
				default:
					return 0;
			}
		} else {
			return 0;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/dashboard/pipes/case.pipe.ts